import { ModuleWithProviders, NgModule } from '@angular/core';
import { LAYOUT_PAGE_TITLE } from '@spaq/core';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { BookingConfirmPageComponent, BookingPageComponent } from './pages';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule, ComboBoxModule, ButtonsModule, ButtonModule],
	declarations: [BookingPageComponent, BookingConfirmPageComponent],
	exports: [BookingPageComponent, BookingConfirmPageComponent]
})
export class BookingModule {
	static forRoot(): ModuleWithProviders<BookingModule> {
		return {
			ngModule: BookingModule,
			providers: [
				{
					provide: LAYOUT_PAGE_TITLE,
					useValue: new BehaviorSubject('Réservation')
				}
			]
		};
	}
}
